import { Grid, Switch, Typography } from "@mui/material";
import { ExternalThawToolActions } from "features/WorklistTools/ExternalThaw/state";
import { SeedingStrategy } from "features/WorklistTools/shared/interfaces";
import { useAppReduxDispatch } from "hooks/reduxHooks";
import { ExternalThawInternalAction } from "../../../state/actions";
import { useExternalThawStateProvider } from "../../../state/StateProvider";

export const SeedingStrategyToggle = () => {
  const { externalThawInternalState, externalThawDispatch } =
    useExternalThawStateProvider();
  const dispatch = useAppReduxDispatch();

  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item>
        <Typography sx={{ textDecoration: "underline" }}>
          Seeding Strategy:
        </Typography>
      </Grid>

      <Grid item>
        <Grid container alignItems="center" spacing={1}>
          <Grid item>Cell Count</Grid>
          <Grid item>
            <Switch
              checked={
                externalThawInternalState.methodSettings.seedingStrategy ===
                SeedingStrategy.Volumetric
              }
              color="primary"
              onChange={(e) => {
                externalThawDispatch({
                  type: ExternalThawInternalAction.SET_SEEDING_STRATEGY,
                  payload: {
                    seedingStrategy: e.target.checked
                      ? SeedingStrategy.Volumetric
                      : SeedingStrategy.CellCount,
                  },
                });
                if (!e.target.checked) {
                  dispatch(
                    ExternalThawToolActions.UPDATE_ALL_DEST_STAMP_CELL_NUMBER({
                      transferVol: "",
                    })
                  );
                }
              }}
              size="medium"
            />
          </Grid>
          <Grid item>Volumetric</Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
